module.exports = __webpack_public_path__ + "img/ys-bg-3.f0c12edd.png";